












import { Component, Prop, Vue } from 'vue-property-decorator'

// store
import { SubjectResource, Subjects } from '@/store/types/schema.training'

@Component
export default class TrainingCard extends Vue {
  @Prop({ required: true })
  private subject!: SubjectResource

  private get subjectColor() {
    return this.colors[this.subject.alias]
  }

  private colors = {
    [Subjects.HISTORY]: 'orange',
    [Subjects.SOCIAL]: 'red',
    [Subjects.LITERATURE]: 'purple',
    [Subjects.RUSSIAN_LANGUAGE]: 'teal',
    [Subjects.BIOLOGY]: 'green',
    [Subjects.ENGLISH_LANGUAGE]: 'grey-pink',
    [Subjects.CHEMISTRY]: 'deep-purple',
    [Subjects.MATHEMATICS]: 'blue',
    [Subjects.PHYSICS]: 'indigo',
    [Subjects.MATHEMATICS_BASE]: 'blue',
    [Subjects.INFORMATICS]: 'turquoise',
  }
}
